<template>
  <v-container fluid class="mb-6">
    <v-card flat>
      <v-row justify="end" align="center">
        <v-col cols="auto" style="text-align: -webkit-center" class="mr-3">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            :return-value.sync="dates"
            transition="scale-transition"
            offset-y
            :max-width="$store.state.isMobile ? '250' : '300'"
            style="z-index: 99999999"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :style="$store.state.isMobile ? 'width: 250px' : 'width: 300px'"
                :value="dateRangeText"
                multiple
                chips
                small-chips
                label="DATE from., to."
                v-bind="attrs"
                v-on="on"
                class="mx-0"
                clearable
                solo
                hide-details
                color="black"
                :disabled="
                  !analytics.WithAnalytics.value ||
                  loader1 ||
                  loader2 ||
                  loader3 ||
                  loader4
                "
                readonly
                @click:clear="(minDate = null), (dates = [])"
              >
                <template v-slot:prepend-inner>
                  <v-icon color="black" dark class="mr-2">mdi-calendar</v-icon>
                </template>
              </v-text-field>
            </template>
            <v-date-picker
              color="black"
              v-model="dates"
              no-title
              scrollable
              range
              full-width
              :max="
                new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                  .toISOString()
                  .substr(0, 10)
              "
              @input="onDateRangeChange"
              :min="minDate"
              :locale="$i18n.locale"
            >
              <v-spacer></v-spacer>
              <v-btn outlined small color="grey" @click="menu1 = false">
                <b>Cancel</b>
              </v-btn>
              <v-btn
                class="white--text"
                small
                color="cleed_blue"
                @click="$refs.menu1.save(dates), start()"
              >
                <b>Ok</b>
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row dense justify="center" align="center" class="pb-6">
        <v-col cols="auto" class="pa-2">
          <v-btn
            :class="tab === 'tab-1' ? 'white--text' : 'black--text'"
            rounded
            :color="tab === 'tab-1' ? 'cleed_blue' : 'white'"
            :disabled="first_time || !analytics.WithAnalytics.tracking"
            @click="tab = 'tab-1'"
          >
            <b> {{ $t("analytics.general.title") }} </b>
          </v-btn>
        </v-col>

        <v-col cols="auto" class="pa-2">
          <v-btn
            v-if="
              $store.state.admin.storeId == '33' ||
              $store.state.admin.storeId == '26'
            "
            :class="tab === 'tab-2' ? 'white--text' : 'black--text'"
            rounded
            :color="tab === 'tab-2' ? 'cleed_blue' : 'white'"
            :disabled="first_time || !analytics.WithAnalytics.tracking"
            @click="tab = 'tab-2'"
          >
            <b> {{ $t("analytics.users.title") }} </b>
          </v-btn>
        </v-col>

        <v-col cols="auto" class="pa-2">
          <v-btn
            :class="tab === 'tab-3' ? 'white--text' : 'black--text'"
            rounded
            :color="tab === 'tab-3' ? 'cleed_blue' : 'white'"
            :disabled="first_time"
            @click="tab = 'tab-3'"
          >
            <b> Conversations </b>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-tabs-items
      v-if="!first_time"
      v-model="tab"
      style="background: rgb(245 245 245)"
    >
      <v-tab-item value="tab-1">
        <v-row justify="center" align="center">
          <!-- visits -->
          <v-col cols="12" lg="12" md="12" sm="12">
            <v-card :loading="loader1" class="ma-auto" elevation="0" outlined>
              <template v-slot:progress>
                <v-row
                  class="fill-height mt-6"
                  align-content="center"
                  justify="center"
                >
                  <v-col cols="6">
                    <v-progress-linear
                      color="deep-purple accent-4"
                      indeterminate
                      rounded
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <v-card-title class="mb-0 pb-0">
                <h4>{{ $t("analytics.general.Visitors.title") }}</h4>
              </v-card-title>
              <v-card-text v-if="!loader1" id="GeneralVisitors">
                <!-- <ExportCard :element="'GeneralVisitors'" /> -->
                <GeneralVisitors />
              </v-card-text>
            </v-card>
          </v-col>

          <!-- bot visits -->
          <v-col cols="12" lg="12" md="12" sm="12">
            <v-card :loading="loader2" class="ma-auto" elevation="0" outlined>
              <template v-slot:progress>
                <v-row
                  class="fill-height mt-6"
                  align-content="center"
                  justify="center"
                >
                  <v-col cols="6">
                    <v-progress-linear
                      color="deep-purple accent-4"
                      indeterminate
                      rounded
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <v-card-title class="mb-0 pb-0">
                <h4>{{ $t("analytics.general.VisitorsBot.title") }}</h4>
              </v-card-title>

              <v-card-text v-if="!loader2" id="GeneralBotVisitors">
                <!-- <ExportCard :element="'GeneralBotVisitors'" /> -->
                <GeneralBotVisitors />
              </v-card-text>
            </v-card>
          </v-col>
          <!-- map usage -->
          <v-col cols="12" lg="12" md="12" sm="12">
            <v-card :loading="loader4" class="ma-auto" elevation="0" outlined>
              <template v-slot:progress>
                <v-row
                  class="fill-height mt-6"
                  align-content="center"
                  justify="center"
                >
                  <v-col cols="6">
                    <v-progress-linear
                      color="deep-purple accent-4"
                      indeterminate
                      rounded
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <v-card-title class="mb-0 pb-0" v-show="loader4">
                <h4>{{ $t("analytics.general.Location.title") }}</h4>
              </v-card-title>
              <v-card-text v-if="!loader4" id="ProfilUtilisation">
                <ExportCard :element="'ProfilUtilisation'" />
                <ProfilUtilisation />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item
        value="tab-2"
        v-if="
          $store.state.admin.storeId == '33' ||
          $store.state.admin.storeId == '26'
        "
      >
        <v-row justify="center" align="center">
          <!--Decision tree-->
          <v-col cols="12" lg="12">
            <v-card
              :loading="(loader3 && loader1) || loader3"
              class="ma-auto"
              elevation="0"
              outlined
            >
              <template v-slot:progress>
                <v-row
                  class="fill-height mt-6"
                  align-content="center"
                  justify="center"
                >
                  <v-col cols="6">
                    <v-progress-linear
                      color="deep-purple accent-4"
                      indeterminate
                      rounded
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <v-card-title class="mb-0 pb-0">
                <h4>{{ $t("analytics.onbording.decision_tree") }}</h4>
              </v-card-title>
              <v-card-text v-if="!loader3" id="Onboarding">
                <!-- <ExportCard :element="'Onboarding'" /> -->
                <Onboarding />
              </v-card-text>
            </v-card>
          </v-col>

          <!--yes.no-->
          <v-col cols="12" lg="12" v-if="$store.state.admin.storeId == '33'">
            <v-card
              :loading="(loader3 && loader1) || loader3"
              class="ma-auto"
              elevation="0"
              outlined
            >
              <template v-slot:progress>
                <v-row
                  class="fill-height mt-6"
                  align-content="center"
                  justify="center"
                >
                  <v-col cols="6">
                    <v-progress-linear
                      color="deep-purple accent-4"
                      indeterminate
                      rounded
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <v-card-title class="mb-0 pb-0">
                <h4>
                  {{ $t("analytics.onbording.satisfaction_and_request") }}
                </h4>
              </v-card-title>
              <v-card-text v-if="!loader3" id="SatisfactionRequest">
                <!-- <ExportCard :element="'SatisfactionRequest'" /> -->
                <SatisfactionRequest />
              </v-card-text>
            </v-card>
          </v-col>

          <!--onbording reco-->
          <v-col cols="12" lg="12" v-if="$store.state.admin.storeId == '33'">
            <v-card
              :loading="(loader3 && loader1) || loader3"
              class="ma-auto"
              elevation="0"
              outlined
            >
              <template v-slot:progress>
                <v-row
                  class="fill-height mt-6"
                  align-content="center"
                  justify="center"
                >
                  <v-col cols="6">
                    <v-progress-linear
                      color="deep-purple accent-4"
                      indeterminate
                      rounded
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <v-card-title class="mb-0 pb-0">
                <h4>{{ $t("analytics.onbording.onboarding_reco") }}</h4>
              </v-card-title>
              <v-card-text v-if="!loader3" id="OnboardingReco">
                <!-- <ExportCard :element="'OnboardingReco'" /> -->
                <OnboardingReco />
              </v-card-text>
            </v-card>
          </v-col>
          <!--onbording reco Christmas-->
          <v-col cols="12" lg="12" v-if="$store.state.admin.storeId == '33'">
            <v-card
              :loading="(loader3 && loader1) || loader3"
              class="ma-auto"
              elevation="0"
              outlined
            >
              <template v-slot:progress>
                <v-row
                  class="fill-height mt-6"
                  align-content="center"
                  justify="center"
                >
                  <v-col cols="6">
                    <v-progress-linear
                      color="deep-purple accent-4"
                      indeterminate
                      rounded
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <v-card-title class="mb-0 pb-0">
                <h4>
                  {{ $t("analytics.onbording.onboarding_reco_christmas") }}
                </h4>
              </v-card-title>
              <v-card-text v-if="!loader3" id="OnboardingRecoChristmas">
                <!-- <ExportCard :element="'OnboardingRecoChristmas'" /> -->
                <OnboardingRecoChristmas />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item value="tab-3">
        <v-row justify="center" align="center">
          <!-- conversations -->
          <v-col cols="12" lg="12" md="12" sm="12">
            <v-card :loading="loader5" class="ma-auto" elevation="0" outlined>
              <template v-slot:progress>
                <v-row
                  class="fill-height mt-6"
                  align-content="center"
                  justify="center"
                >
                  <v-col cols="6">
                    <v-progress-linear
                      color="deep-purple accent-4"
                      indeterminate
                      rounded
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <v-card-title class="mb-0 pb-0">
                <h4>
                  {{ $t("analytics.conversations.number_conversations.title") }}
                </h4>
              </v-card-title>

              <v-card-text v-if="!loader5" id="Conversations">
                <!-- <ExportCard :element="'Conversations'" /> -->
                <Conversations />
              </v-card-text>
            </v-card>
          </v-col>
          <!-- NPS and CES -->
          <v-col cols="12" lg="12" md="12" sm="12">
            <v-card :loading="loader8" class="ma-auto" elevation="0" outlined>
              <template v-slot:progress>
                <v-row
                  class="fill-height mt-6"
                  align-content="center"
                  justify="center"
                >
                  <v-col cols="6">
                    <v-progress-linear
                      color="deep-purple accent-4"
                      indeterminate
                      rounded
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <v-card-title class="mb-0 pb-0">
                <h4>
                  {{ $t("analytics.conversations.rating.title") }}
                </h4>
              </v-card-title>

              <v-card-text v-if="!loader8" id="Rating">
                <ExportCard :element="'Rating'" />
                <Rating />
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="12" md="12" sm="12">
            <v-card :loading="loader9" class="ma-auto" elevation="0" outlined>
              <template v-slot:progress>
                <v-row
                  class="fill-height mt-6"
                  align-content="center"
                  justify="center"
                >
                  <v-col cols="6">
                    <v-progress-linear
                      color="deep-purple accent-4"
                      indeterminate
                      rounded
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <v-card-title class="mb-0 pb-0">
                <h4>Conversation major topics</h4>
              </v-card-title>

              <v-card-text v-if="!loader9" id="ChatOccurence">
                <ChatOccurrence />
              </v-card-text>
            </v-card>
          </v-col>

          <!-- conversations stplits -->
          <v-col cols="12" lg="12" md="12" sm="12">
            <v-card :loading="loader6" class="ma-auto" elevation="0" outlined>
              <template v-slot:progress>
                <v-row
                  class="fill-height mt-6"
                  align-content="center"
                  justify="center"
                >
                  <v-col cols="6">
                    <v-progress-linear
                      color="deep-purple accent-4"
                      indeterminate
                      rounded
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <v-card-title class="mb-0 pb-0">
                <h4>
                  {{
                    $t(
                      "analytics.conversations.conversations_split_status.title"
                    )
                  }}
                </h4>
              </v-card-title>

              <v-card-text v-if="!loader6" id="ConversationsSplit">
                <!-- <ExportCard :element="'ConversationsSplit'" /> -->
                <ConversationsSplit />
              </v-card-text>
            </v-card>
          </v-col>

          <!-- conversations time -->
          <v-col cols="12" lg="12" md="12" sm="12">
            <v-card :loading="loader10" class="ma-auto" elevation="0" outlined>
              <template v-slot:progress>
                <v-row
                  class="fill-height mt-6"
                  align-content="center"
                  justify="center"
                >
                  <v-col cols="6">
                    <v-progress-linear
                      color="deep-purple accent-4"
                      indeterminate
                      rounded
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <v-card-title class="mb-0 pb-0">
                <h4>
                  {{ $t("analytics.conversations.messages_time.title") }}
                </h4>
              </v-card-title>

              <v-card-text v-if="!loader10" id="MessagesTime">
                <MessagesTime />
              </v-card-text>
            </v-card>
          </v-col>

          <!-- conversations subjects -->
          <v-col cols="12" lg="12" md="12" sm="12">
            <v-card :loading="loader7" class="ma-auto" elevation="0" outlined>
              <template v-slot:progress>
                <v-row
                  class="fill-height mt-6"
                  align-content="center"
                  justify="center"
                >
                  <v-col cols="6">
                    <v-progress-linear
                      color="deep-purple accent-4"
                      indeterminate
                      rounded
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <v-card-title class="mb-0 pb-0">
                <h4>
                  {{
                    $t(
                      "analytics.conversations.conversations_subjects_split.title"
                    )
                  }}
                </h4>
              </v-card-title>

              <v-card-text v-if="!loader7" id="ConversationSubjects">
                <!-- <ExportCard :element="'ConversationSubjects'" /> -->
                <ConversationSubjects />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
    <v-card v-else>
      <v-card-text>
        <v-row justify="center" v-if="!analytics.WithAnalytics.value">
          <v-col cols="auto" class="ma-12 pa-12">
            Store with no analytics
          </v-col>
        </v-row>
        <v-row justify="center" v-else>
          <v-col cols="auto" class="ma-12 pa-12"> Please select dates </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-fab-transition>
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        fab
        dark
        fixed
        bottom
        color="#1141ce"
        @click="$vuetify.goTo(0)"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-container>
</template>

<script>
import ExportCard from "../components/analytics/ExportCard.vue";
import GeneralVisitors from "@/components/analytics/GeneralVisitors";
import GeneralBotVisitors from "@/components/analytics/GeneralBotVisitors";
import Onboarding from "../components/analytics/Onboarding";
import OnboardingReco from "../components/analytics/onbording/LE/OnboardingReco";
import OnboardingRecoChristmas from "../components/analytics/onbording/LE/OnboardingRecoChristmas";
import SatisfactionRequest from "../components/analytics/onbording/LE/Satisfaction&Request";
import ProfilUtilisation from "../components/analytics/ProfilUtilisation";
import ConversationsSplit from "../components/analytics/Conversation_split";
import Conversations from "../components/analytics/Conversations";
import ConversationSubjects from "../components/analytics/ConversationSubjects";
import Rating from "../components/analytics/Rating";
import ChatOccurrence from "../components/analytics/ChatOccurrence.vue";
import MessagesTime from "../components/analytics/MessagesTime.vue";

export default {
  components: {
    GeneralVisitors,
    GeneralBotVisitors,
    Onboarding,
    ProfilUtilisation,
    ConversationsSplit,
    Conversations,
    ConversationSubjects,
    OnboardingReco,
    OnboardingRecoChristmas,
    SatisfactionRequest,
    ExportCard,
    Rating,
    ChatOccurrence,
    MessagesTime,
  },
  data() {
    return {
      first_time: true,
      tab: null,
      dates: [],
      menu1: false,
      loader1: false,
      loader2: false,
      loader3: false,
      loader4: false,
      loader5: false,
      loader6: false,
      loader7: false,
      loader8: false,
      loader9: false,
      loader10: false,
      fab: false,
      minDate: null,
    };
  },
  computed: {
    analytics() {
      const data = this.$store.state.analytics;
      return data;
    },
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
  },
  created() {
    if (this.analytics?.WithAnalytics?.tracking) {
      this.tab = "tab-1";
    } else {
      this.tab = "tab-3";
    }
  },
  mounted() {},
  methods: {
    onDateRangeChange() {
      this.minDate = this.dates.length ? this.dates[0] : null;
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 200;
    },
    get_anatytics(dates) {
      if (this.analytics.WithAnalytics.tracking) {
        console.log("in tracking");
        this.loader1 = true;
        this.$store
          .dispatch("FETCH_ANALYTICS_VIS", {
            dates,
          })
          .then((r) => {
            // console.log(r);
            this.loader1 = false;
          })
          .catch((err) => {
            console.log(err);
            this.$store.dispatch("setSnackbar", {
              text: `TimeOut conversion`,
              color: "error",
              timeout: 2000,
            });
            this.loader1 = false;
          });
        ////////////////////////
        this.loader2 = true;
        this.$store
          .dispatch("FETCH_ANALYTICS_VISBOT", {
            dates,
          })
          .then((r) => {
            // console.log(r);
            this.loader2 = false;
          })
          .catch((err) => {
            this.$store.dispatch("setSnackbar", {
              text: `TimeOut conversion`,
              color: "error",
              timeout: 2000,
            });
            this.loader2 = false;
          });
        //////////////////////
        if (
          this.$store.state.admin.storeId == "33" ||
          this.$store.state.admin.storeId == "35" ||
          this.$store.state.admin.storeId == "26"
        ) {
          this.loader3 = true;
          this.$store
            .dispatch("FETCH_ANALYTICS_ONBOARDING", {
              dates,
            })
            .then((r) => {
              // console.log(r);
              this.loader3 = false;
            })
            .catch((err) => {
              this.$store.dispatch("setSnackbar", {
                text: `TimeOut onbording`,
                color: "error",
                timeout: 2000,
              });
              this.loader3 = false;
            });
        }
        ////////////////
        this.loader4 = true;
        this.$store
          .dispatch("FETCH_ANALYTICS_LOCATION", {
            dates,
          })
          .then((r) => {
            // console.log(r);
            this.loader4 = false;
          })
          .catch((err) => {
            this.$store.dispatch("setSnackbar", {
              text: `TimeOut localisation`,
              color: "error",
              timeout: 2000,
            });
            this.loader4 = false;
          });
      }
      ////////////////////
      this.loader5 = true;
      this.$store
        .dispatch("FETCH_SPLIT_CONVERSATIONS", { dates })
        .then((r) => {
          // console.log(r);
          this.loader5 = false;
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            text: `TimeOut conversation`,
            color: "error",
            timeout: 2000,
          });
          this.loader5 = false;
        });
      //////////////////////////
      this.loader6 = true;
      this.$store
        .dispatch("FETCH_SPLIT_SENDER", {
          dates,
        })
        .then((r) => {
          // console.log(r);
          this.loader6 = false;
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            text: `TimeOut conversation`,
            color: "error",
            timeout: 2000,
          });
          this.loader6 = false;
        });
      ////////////////////////
      this.loader7 = true;
      this.$store
        .dispatch("FETCH_CONVERSATION_SUBJECTS", {
          dates,
        })
        .then((r) => {
          // console.log(r);
          this.loader7 = false;
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            text: `TimeOut conversation`,
            color: "error",
            timeout: 2000,
          });
          this.loader7 = false;
        });
      ////////////////////////
      this.loader8 = true;
      this.$store
        .dispatch("FETCH_RATING", {
          dates,
        })
        .then(() => {
          this.loader8 = false;
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            text: `TimeOut conversation`,
            color: "error",
            timeout: 2000,
          });
          this.loader8 = false;
        });
      ////////////////////////
      this.loader9 = true;
      this.$store
        .dispatch("FETCH_CONVERSATIONS_MAJOR_TOPICS", {
          dates,
        })
        .then(() => {
          this.loader9 = false;
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            text: `TimeOut conversation`,
            color: "error",
            timeout: 2000,
          });
          this.loader9 = false;
        });
      ////////////////////////
      this.loader10 = true;
      this.$store
        .dispatch("FETCH_MESSAGES_TIME", {
          dates,
        })
        .then(() => {
          this.loader10 = false;
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            text: `TimeOut conversation`,
            color: "error",
            timeout: 2000,
          });
          this.loader10 = false;
        });
    },
    start() {
      if (this.dates.length == 2) {
        const dates = {
          from: {
            day: "",
            mon: "",
            year: "",
          },
          to: {
            day: "",
            mon: "",
            year: "",
          },
        };
        const from_split = this.dates[0].split("-");
        const to_split = this.dates[1].split("-");
        dates.from.day = parseInt(from_split[2]).toString();
        dates.from.mon = parseInt(from_split[1]).toString();
        dates.from.year = parseInt(from_split[0]).toString();
        dates.to.day = parseInt(to_split[2]).toString();
        dates.to.mon = parseInt(to_split[1]).toString();
        dates.to.year = parseInt(to_split[0]).toString();

        this.analytics.visitors = undefined;
        this.analytics.botVisitors = undefined;
        this.analytics.onboarding = undefined;
        (this.analytics.ProfilUtilisation = { CountryData: {} }),
          (this.analytics.SplitStatus = undefined);
        this.analytics.SplitSender = undefined;
        this.analytics.Conversations = undefined;
        this.analytics.ConversationSubjects = {};
        this.analytics.VisitsHeatmap = undefined;
        this.get_anatytics(dates);
        this.first_time = false;
        // this.tab = "tab-1" || 0;
      } else {
        this.$store.dispatch("setSnackbar", {
          text: `Please fill the dates FROM - TO`,
          color: "warning",
          timeout: 2000,
        });
      }
    },
  },
};
</script>
<style scoped></style>
